import { useTranslation } from 'next-i18next';
import { Button } from '@components/common';
import { SidebarFooterProps } from '@type/filters';

/**
 * @description The sidebar footer component.
 */
export const SidebarFooter = (props: SidebarFooterProps) => {
  // Destructure props
  const {
    showDetails,
    setShowDetails,
    toggleDrawer,
  } = props;

  // Translation
  const { t } = useTranslation('common');

  // Render component
  // ***********************************************
  return (
    <div className="shrink-0 border-t-6 border-b-surface-100 p-4">

      {/* Submit button */}
      <Button
        type="submit"
        color="secondary"
        rounding="full"
        className="w-full !px-8 sm:w-auto"
        onClick={() => {
          // close the drawer if we're not in a filter category group
          if (!showDetails && toggleDrawer) toggleDrawer();
          setShowDetails(false);
        }}
      >
        {t('global.action.apply_filters')}
      </Button>

    </div>
  );
};
